import header from './mapHeaderContent'
import accordion from './mapAccordionContent'
import link from './mapMoreDetailsLink'

export const mapPinContent = (data) => {
  return `
    <div class="mapServiceDetails pa-4">
      ${header(data)}
      ${accordion(data)}
      ${link(data)}
    </div>
  `
}

export const mapPinContentLoading = () => {
  return `
  <div style="min-width: 150px;" class="px-5 pb-2 pt-5">
    <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear v-progress-linear--rounded v-progress-linear--visible theme--light" style="height: 6px;">
      <div class="v-progress-linear__background grey accent-4" style="opacity: 0.3; left: 0%; width: 100%;"></div>
      <div class="v-progress-linear__buffer"></div>
      <div class="v-progress-linear__indeterminate v-progress-linear__indeterminate--active">
        <div class="v-progress-linear__indeterminate long grey accent-4"></div>
        <div class="v-progress-linear__indeterminate short grey accent-4"></div>
      </div>
    </div>
  </div>
  `
}
